const flattenObject = (
  target,
  allowNullValue,
  separator,
  currentValue,
  currentKey
) => {
  if (currentValue === null || currentValue === undefined) {
    if (allowNullValue) target[currentKey] = currentValue;
  } else if (
    typeof currentValue === "number" ||
    typeof currentValue === "string" ||
    Array.isArray(currentValue)
  ) {
    target[currentKey] = currentValue;
  } else if (
    typeof currentValue === "boolean" ||
    typeof currentValue !== "object"
  ) {
    target[currentKey] = currentValue.toString();
  } else {
    const prefix = currentKey ? `${currentKey}${separator}` : currentKey;
    for (const key in currentValue) {
      flattenObject(
        target,
        allowNullValue,
        separator,
        currentValue[key],
        prefix + key
      );
    }
  }
};

export const flatten = (input, allowNullValue = false, separator = ".") => {
  const output = {};
  if (input && typeof input === "object") {
    flattenObject(output, allowNullValue, separator, input, "");
  }
  return output;
};

export function withSignal(inputPromise, signal) {
  return new Promise(async (resolve, reject) => {
    if (signal?.aborted) {
      reject(signal?.reason);
      return;
    }

    signal?.addEventListener("abort", () => {
      reject(signal?.reason);
    });

    try {
      const result = await inputPromise;
      resolve(result);
    } catch (error) {
      reject(error);
    }
  });
}

export const processInWorker = ({ messageData, messageID, messageTopic }) => {
  return new Promise((resolve, reject) => {
    const worker = new Worker(
      new URL("./worker/dataExportWorker.js", import.meta.url)
    );

    worker.addEventListener("message", ({ data }) => {
      if (data.messageTopic === messageTopic && data.messageID === messageID) {
        resolve(data.output);
        worker.terminate();
      }
    });

    worker.addEventListener("error", (error) => {
      reject(error);
      worker.terminate();
    });

    worker.postMessage({
      messageData,
      messageID,
      messageTopic,
    });
  });
};
